import "./styles.css";

import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
//import AuthForm from "./components/AuthForm";
import ReportForm from "./components/ReportForm";
import BuscarObjetos from "./components/BuscarObjetos";
import BotonCompartir from "./components/BotonCompartir";

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setUsuario(user);
    });
    return () => unsub();
  }, []);

  const handleReportarClick = () => {
    //if (usuario) {
    setMostrarFormulario(true);
    setTimeout(() => {
      document
        .getElementById("reportar")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 100); // pequeño delay para que el form aparezca antes de scrollear
    //} else {
    //  setMostrarFormulario("login");
    //}
  };

  return (
    <>
      <header className="fixed w-full z-10">
        <div className="max-w-6xl mx-auto p-4 space-y-6">
          <a href="https://www.clubsanfernando.org.ar/" title="Ir al sitio web">
            <img
              src="/images/logo.png"
              alt="Club San Fernando"
              width="50"
              className="-mt-7 -mb-12 md:-mt-8 md:-mb-14 w-64 md:w-80"
            />
          </a>
        </div>
      </header>
      <main className="">
        <section className="max-w-6xl mx-auto p-4 space-y-6">
          <div className="flex flex-col w-full pt-32 pb-16 md:py-32 lg:py-40 gap-4 max-w-2xl">
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl lg:text-6xl">
              ¿Perdiste o encontraste algo en el Club?
            </h1>
            <p className="text-l md:text-xl">
              Acá podés buscar o reportar un objeto, muy fácil!
              <br />
              Hacé clic en "Reportar objeto" o navegá por los objetos usando el
              buscador.
              <br />
              ¡Ayudémonos entre todos!
            </p>
            <div className="inline-flex flex-col gap-2 md:flex-row relative">
              <button
                onClick={handleReportarClick}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2 justify-center "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4"
                >
                  <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
                  <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
                </svg>
                Reportar objeto
              </button>
              <a
                href="#buscador"
                className="text-center border px-4 py-2 rounded flex items-center gap-2 justify-center bg-white hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.3-4.3"></path>
                </svg>
                Buscar objeto
              </a>
              <BotonCompartir
                id=""
                descripcion=""
                className="relative top-auto right-auto px-4 py-2"
                text="Compartir"
                link="https://clubsanfernando.org.ar/encontralo"
              />
            </div>
          </div>
        </section>

        {mostrarFormulario === true && (
          <section id="reportar" className="mt-4 p-6 py-32 bg-blue-100">
            <div className="relative w-full max-w-md mx-auto ">
              <button
                onClick={() => setMostrarFormulario(false)}
                className="w-4 h-4 justify-center flex absolute right-5 top-5"
                title="Cerrar"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-x-icon lucide-x w-4 h-4"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>

              <ReportForm usuario={usuario} />
            </div>
          </section>
        )}

        <BuscarObjetos usuario={usuario} />
      </main>

      <footer>
        <div className="max-w-6xl mx-auto p-4 space-y-2 text-gray-400 flex items-center flex-col text-center md:justify-between md:flex-row-reverse">
          <ul className="flex gap-2">
            <li className="hidden md:inline">Seguinos</li>
            <li>
              <a
                title="Seguinos en Instagram"
                href="https://instagram.com/csf_oficial?igshid=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-instagram-icon lucide-instagram"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
              </a>
            </li>
            <li>
              <a
                title="Ir al Canal de WhatsApp"
                href="https://whatsapp.com/channel/0029Vb5rm0p6RGJEf1wrdK3L?igshid=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"></path>
                </svg>
              </a>
            </li>
          </ul>
          <p>
            ©2026 <strong>Club San Fernando</strong>. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </>
  );
}
